import React from "react";

const Header = () => {
    return (
        <header className="app-header">
            <h1>CUE.</h1>
        </header>
    );
};

export default Header;